import { css } from 'linaria';
import { Variables } from '../index';

export const theme = css`
    :global() {
        [data-theme='light'] {
            --tab-header-shadow: inset 0px -1px 0px ${Variables.css.grey2};
            --tab-trigger-color: ${Variables.css.grey2};
            --tab-trigger-inactive: ${Variables.css.catapultBlack};
        }

        [data-theme='dark'] {
            --tab-header-shadow: none;
            --tab-trigger-color: ${Variables.css.catapultWhite};
            --tab-trigger-inactive: ${Variables.css.catapultWhite};
        }
    }
`;

export const headerTabs = css`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    box-shadow: var(--tab-header-shadow);
`;

export const trigger = css`
    display: inline-flex;
    appearance: none;
    background: transparent;
    border: 0;
    position: relative;

    color: var(--tab-trigger-color);
    font-weight: normal;

    padding: ${Variables.css.spacing12} ${Variables.css.spacing8};

    & + & {
        margin-left: ${Variables.css.spacing12};
    }

    &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 4px;
        width: 100%;
        border-bottom: 4px solid ${Variables.css.catapultOrange};
        opacity: 0;
    }
`;

export const states = css`
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        border-radius: 0;
    }

    [data-theme='light'] &:hover {
        &::after {
            background: rgba(16, 16, 16, 0.04);
            border-bottom: 2px solid var(--tab-trigger-inactive);
            cursor: pointer;
        }
    }

    [data-theme='light'] &:active,
    [data-theme='light'] &:focus-visible {
        &::after {
            background: rgba(16, 16, 16, 0.12);
            border-bottom: 1px solid var(--tab-trigger-inactive);
        }
    }

    [data-theme='dark'] &:hover {
        &::after {
            background: rgba(255, 255, 255, 0.08);
            border-bottom: 2px solid var(--tab-trigger-inactive);
            cursor: pointer;
        }
    }

    [data-theme='dark'] &:active {
        &::after {
            background: rgba(255, 255, 255, 0.32);
            border-bottom: 1px solid var(--tab-trigger-inactive);
        }
    }
    &[data-state='active'] {
        font-weight: bold;

        &:before {
            opacity: 1;
        }
    }

    &:focus-visible {
        box-shadow: 0 0 0 4px ${Variables.css.information};
        outline: none;
    }
`;
